/** Shared floating surfaces for dashboard charts (aligned with vendor profile cards). */
export const DASHBOARD_PAGE_BG = "#f5f5f5";
export const DASHBOARD_CHART_CONTENT_MAX_WIDTH = 1000;

export const dashboardFiltersShellTransitionSx = {
  width: "100%",
  maxWidth: "100%",
  transition: "max-width 100ms ease",
};

export const dashboardFloatingCardSx = {
  p: { xs: 2, sm: 2.5, md: 3 },
  borderRadius: "20px",
  border: "1px solid rgba(0,0,0,0.06)",
  backgroundColor: "#ffffff",
  boxShadow: "0 0 9px rgba(0,0,0,0.08)",
};

export const dashboardChartsContentCardSx = {
  ...dashboardFloatingCardSx,
  borderRadius: "20px",
  p: { xs: 2, sm: 3, md: 4 },
};

/** Single-tab charts whose rows are already floating cards (no outer white shell). */
export const dashboardChartsPlainContentSx = {
  bgcolor: "transparent",
  border: "none",
  boxShadow: "none",
  p: 0,
};

export const dashboardChartTileCardSx = {
  ...dashboardFloatingCardSx,
  borderRadius: "20px",
  p: { xs: 2, sm: 2.5, md: 3 },
  height: "100%",
  boxSizing: "border-box",
};

export const dashboardChartsSectionSpacing = { xs: 3, sm: 4 };

export const dashboardChartsGridGap = dashboardChartsSectionSpacing;

export const dashboardChartsTitleSx = {
  fontFamily: "Rubik, sans-serif",
  fontWeight: 700,
  fontSize: { xs: "1.15rem", sm: "1.35rem" },
  color: "#0b3d87",
  lineHeight: 1.25,
};

export const dashboardFiltersLabelSx = {
  fontFamily: "Rubik, sans-serif",
  fontWeight: 700,
  fontSize: { xs: "1rem", sm: "1.125rem" },
  color: "#0b3d87",
  lineHeight: 1.25,
  flexShrink: 0,
};

export const dashboardTabSelectorShellSx = {
  bgcolor: "#ffffff",
  borderRadius: "999px",
  p: 0,
  gap: 0.25,
  boxShadow: "0 8px 28px rgba(11, 61, 135, 0.07)",
  border: "1px solid rgba(0,0,0,0.06)",
};

export const chartTileTitleSx = {
  fontFamily: "Rubik",
  fontWeight: "bold",
  color: "#626262",
  fontSize: 15,
  mb: 1.5,
  display: "block",
  width: "100%",
  textAlign: "left",
  border: "none",
  background: "none",
  padding: 1,
  cursor: "pointer",
  "&:hover": { textDecoration: "underline" },
};
